import { Groups, Security, Diversity3, School, ArrowForward } from "@mui/icons-material";
import { Button, Container } from "@mui/material";
import { useNavigate } from "react-router-dom";
import React, { useEffect } from "react";
import AOS from "aos";
import "aos/dist/aos.css";
import FounderImg from "../Assets/FPS_Chairman.jpeg";

const Feature = () => {
  const navigate = useNavigate();

  useEffect(() => {
    AOS.init({ duration: 900, once: true });
  }, []);

  const features = [
    { icon: <Groups />, title: "Qualified & Caring Teachers" },
    { icon: <Security />, title: "Safe & Secure Campus" },
    { icon: <Diversity3 />, title: "Inclusive Environment" },
    { icon: <School />, title: "Future-Ready Learning" },
  ];

  return (
    <div className="overflow-hidden">

      <div className="elementor-widget-container my-4">
        <div className="tm-modern-heading">
          <div className="heading-primary-wrap">
            <h2 className="heading-primary elementor-heading-title">Welcome to Fatehpur Public School</h2></div>
          <div className="heading-divider my-3"></div>
          <div className="heading-description-wrap">
            <div className="heading-description">
              <p className="heading-description">Knowledge is power</p></div>
          </div>
        </div>
      </div>

      <section className="relative py-28 bg-[#F5F7FA]">
        <Container maxWidth="lg">
          <div className="grid md:grid-cols-2 gap-16 items-center">

            <div data-aos="fade-right">
              <p className="text-[#F4B400] font-semibold mb-3 uppercase tracking-widest">
                Who We Are
              </p>
              <h2 className="text-5xl font-extrabold text-[#0A1F44] mb-6 leading-tight">
                Growing Minds.<br />Building Character.
              </h2>
              <p className="text-lg text-gray-700 leading-relaxed">
                Fatehpur Public School nurtures children in a joyful, safe, and value-driven
                environment where curiosity meets confidence. We believe every child is unique
                and full of potential, and our mission is to help them grow academically,
                socially, and emotionally. Through engaging classroom experiences, creative
                activities, and strong moral guidance, we build a foundation that inspires a
                lifelong love for learning. Our dedicated educators focus on developing
                critical thinking, communication skills, and character, ensuring students
                are prepared not just for exams, but for life. At Fatehpur Public School,
                education goes beyond books — we shape responsible, confident, and
                compassionate individuals ready to embrace the future.
              </p>

            </div>

            <div className="space-y-5">
              {features.map((feature, i) => (
                <div key={i}
                  data-aos="fade-left"
                  data-aos-delay={i * 100}
                  className="flex items-center gap-5 bg-white p-5 rounded-2xl shadow-md hover:shadow-xl transition-all">
                  <div className="bg-[#0A1F44]/10 p-4 rounded-xl text-[#0A1F44]">
                    {feature.icon}
                  </div>
                  <h3 className="font-semibold text-[#1A1A1A]">{feature.title}</h3>
                </div>
              ))}
            </div>

          </div>
        </Container>
      </section>

      <section className="py-28 bg-white">
        <Container maxWidth="lg">
          <div className="grid md:grid-cols-2 gap-16 items-center">

            <div data-aos="fade-right">
              <img src={FounderImg} alt="Chairman" className="rounded-3xl shadow-2xl object-cover object-[center_33%] w-full max-h-[420px]" />
            </div>

            <div data-aos="fade-left">
              <h2 className="text-4xl font-bold text-[#0A1F44] mb-6">
                A Message from the Chairman
              </h2>
              <p className="text-lg text-gray-700 leading-relaxed">
                Education should inspire curiosity and confidence, not pressure. Our mission
                is to make learning joyful, meaningful, and purposeful, where every child
                feels valued, supported, and motivated to explore their unique potential.
                We believe that true education goes beyond textbooks — it shapes character,
                builds resilience, and develops a lifelong love for learning.<br />

                Together, we nurture confident, compassionate, and future-ready individuals
                who are prepared to adapt, contribute, and succeed in an ever-changing world.

              </p>

              <div className="mt-6 border-l-4 border-[#F4B400] pl-4">
                <p className="font-bold">Mr. Reaz Zaidi</p>
                <p className="text-[#F4B400] font-semibold">Chairman</p>
              </div>
            </div>

          </div>
        </Container>
      </section>

      <section className="py-28 bg-[#0A1F44]">
        <Container maxWidth="lg">
          <div className="grid md:grid-cols-2 gap-10">

            {[{
              title: "Our Vision",
              text: "To develop confident, ethical, and curious learners prepared for lifelong success."
            }, {
              title: "Our Mission",
              text: "To provide a nurturing, equitable, and engaging environment where every child thrives."
            }].map((item, i) => (
              <div key={i}
                data-aos="zoom-in"
                className="backdrop-blur-md bg-white/10 border border-white/20 p-10 rounded-3xl shadow-xl text-white">
                <h2 className="text-3xl font-bold text-[#F4B400] mb-4">{item.title}</h2>
                <p className="text-lg leading-relaxed">{item.text}</p>
              </div>
            ))}

          </div>
        </Container>
      </section>

      <section className="py-28 bg-[#F5F7FA]">
        <Container maxWidth="lg">
          <div className="bg-gradient-to-r from-[#0A1F44] to-[#071630] rounded-3xl p-12 text-white flex flex-col md:flex-row justify-between items-center gap-6 shadow-2xl"
            data-aos="zoom-in">

            <div>
              <h2 className="text-3xl font-bold mb-2">
                Begin Your Child’s Learning Journey
              </h2>
              <p className="text-white/80">
                Admissions are open. Join a school where learning meets values.
              </p>
            </div>

            <Button
              variant="contained"
              endIcon={<ArrowForward />}
              sx={{
                backgroundColor: "#F4B400",
                color: "#1A1A1A",
                fontWeight: "bold",
                padding: "12px 34px",
                borderRadius: "10px",
                "&:hover": { backgroundColor: "#ffd54f" }
              }}
              onClick={() => navigate(`/AdmissionForm?Type=AdmissionForm`)}
            >
              Apply Now
            </Button>

          </div>
        </Container>
      </section>
    </div>
  );
};

export default Feature;
